import React from "react";
import ImageWall from "../components/imageWall/imageWall";
import Header from "../components/header/header";
import FormFour from "../components/form/formFour/formFour";
import { useLocation } from "react-router-dom";

const CreditFour = () => {
  const location = useLocation();
  const user = location.state;
  return (
    <ImageWall>
      <Header
        title="Bienvenido a préstamo online"
        text="Completa los datos requeridos de un familiar en pantalla, ya que lo usaremos para verificar la información"
      />
      <FormFour userFour={user} />
    </ImageWall>
  );
};

export default CreditFour;
